<template>
  <div id="app">
    <!--一级 路由出口 -->
    <!-- <router-view></router-view> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <div class="hotLine">
      <div v-if="$route.path != '/tv'">
        <div class="phone_hot">
          <img class="phones" src="./assets/img/directChat/hotLine.png" alt="" />
          <div>企业招聘热线：0931-8874777</div>
        </div>
        <div class="phone_hot">
          <img class="phones" src="./assets/img/directChat/hotLine.png" alt="" />
          <div>求职服务热线：0931-8811283</div>
        </div>
        <div class="phone_hot">
          <img class="phones" src="./assets/img/directChat/hotLine.png" alt="" />
          <div>猎头交付热线：0931-8748016</div>
        </div>
        <div class="phone_hot">
          <img class="phones" src="./assets/img/directChat/hotLine.png" alt="" />
          <div>派遣员工热线：0931-8240555</div>
        </div>
        <div class="phone_hot">
          <img class="phones" src="./assets/img/directChat/hotLine.png" alt="" />
          <div>投诉电话：0931-8821509</div>
        </div>
      </div>
      <div v-if="websocketFlag && show">
        <Websocket />
        <!-- 直聊 -->
        <div class="phone_hot" @click="skipChat">
          <a-badge :count="ImMessageCount">
            <img
              style="width: 35px; height: 35px"
              src="./assets/img/directChat/chat.png"
              alt=""
            />
          </a-badge>
          <p class="chat_text">直聊</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Websocket from "@/components/Websocket/index";
import Cookies from "js-cookie";
import localstorage from "@/utils/localstorage";

export default {
  scrollToTop: true,
  name: "App",
  components: { Websocket },
  data() {
    // 数据
    return {
      // websocketFlag: false,
      websocketFlag: true,
      show: true,
      ImMessageCount: 0,
    };
  },

  // 企业注册浏览协议保留当前数据
  watch: {
    $route(to, from) {
      // console.log(to,from)
      if (to.query.path == "/agreement") {
        to.meta.keepAlive = true;
      } else {
        to.meta.keepAlive = false;
      }
      if (to.path == "/login" || to.path == "/poster" || to.path == "/tv") {
        this.show = false;
      } else {
        this.show = true;
      }
    },
  },
  mounted() {
    if (Cookies.get("CompanyAuthorization")) {
      console.log("CompanyAuthorization");
      this.websocketFlag = true;
    }

    if (Cookies.get("JobseekerAuthorization")) {
      console.log("JobseekerAuthorization");
      this.websocketFlag = true;
    }

    this.event.$on("LOGIN_FLAG", (e) => {
      this.websocketFlag = true;
    });
    this.event.$on("IM_MESSAGE_COUNT", (e) => {
      this.ImMessageCount = e;
      console.log(e, "eeeeeeeeeeeeee");
    });
    window.addEventListener(
      "scroll",
      function () {
        const scrollHeight = document.documentElement.scrollHeight;
        let scrollTop = document.documentElement.scrollTop;
        let dom = document.querySelector(".chat_text");
        if (dom) {
          // console.log(scrollHeight-1050 , scrollTop)
          if (scrollHeight - 1050 < scrollTop) {
            dom.style.color = "#1890ff";
          } else {
            dom.style.color = "#333";
          }
        }
      },
      false
    );
  },
  methods: {
    /* 跳转到直聊 */
    skipChat() {
      this.$router.push("/directChat");
    },
  },
};
</script>

<style>
#app {
  overflow: hidden;
}
div {
  word-break: break-all;
}

/* 有效区 */
.layout {
  width: 1200px;
  margin: 0 auto;
}

::-webkit-scrollbar {
  display: none;
}

.components-pagination-mini {
  width: 100%;
  position: relative;
  height: 50px;
  /* background-color: rgb(225, 59, 59); */
}

.ant-pagination {
  display: inline-block;
  font-size: 16px !important;
  font-family: Microsoft YaHei !important;
  font-weight: 400 !important;
  color: #000000 !important;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.ant-pagination-item-active a {
  color: #00479d !important;
}

.ant-pagination-item-active {
  /* background: transparent !important;
  border-color: transparent !important; */
}

.anticon {
  color: #000;
}

.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link,
.ant-pagination-item {
  /* border: 1px solid transparent !important;
  background-color: transparent !important; */
}

.anchorBL img {
  display: none;
}

.BMap_cpyCtrl span {
  display: none !important;
}
.hotLine {
  position: fixed;
  bottom: 20%;
  right: 2%;
  align-items: center;
  cursor: pointer;
  z-index: 100;
}
.phone_hot {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.phones {
  width: 35px;
  height: 35px;
}
.phone_hot > div {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-left: 5px;
}
/* 直聊 */
.chat {
  position: fixed;
  bottom: 15%;
  right: 8%;
  display: flex;
  align-items: center;
  cursor: pointer;
  z-index: 100;
}

.chat img {
  width: 46px;
  height: 46px;
}

.phone_hot .chat_text {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-left: 5px;
}

/*//修改disabled属性的input样式*/
.ant-btn[disabled] {
  background-color: #b6b6b6 !important;
  color: #fff !important;
  border-color: #b6b6b6 !important;
}

/* 在Chrome浏览器下 */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

/* 在Firefox浏览器下 */
input[type="number"] {
  -moz-appearance: textfield !important;
}
</style>
